import PossibleBaseData from './PossibleBaseData';
import PossibleFoundationTypeDetail from './PossibleFoundationTypeDetail';
// Import enumerations.
import {
	BuildingFoundationType,
} from '@app/enumerations';

export default class PossibleFoundationType extends PossibleBaseData {

	public displayName: string | null = null;
	public code: BuildingFoundationType | null = null;
	public possibleBuildingFoundationDetails: PossibleFoundationTypeDetail[] = [];

	public constructor() {
		super();
	}
};